import React from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom"; // Use HashRouter
import Header from "./components/Header";
import Login from "./components/Login";
import TransactionsPage from "./components/Pages/TransactionsPage"; // Import additional pages
import WithdrawRequestsPage from "./components/Pages/WithdrawRequestsPage";
import WalletBalancePage from "./components/Pages/WalletBalancePage";
import ComplaintsPage from "./components/Pages/ComplaintsPage";
import LoginPage from "./pages/LoginPage";
import TwoFactorAuthPage from "./pages/TwoFactorAuthPage";
import RoleManagementPage from "./pages/RoleManagementPage";
import SettingsPage from "./pages/SettingsPage";
import WalletServiceTypesPage from "./pages/WalletServiceTypesPage";
import WalletServiceTypeDetailPage from "./pages/WalletServiceTypeDetailPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AuthGuard from "./components/AuthGuard";
import PermissionRoute from "./components/PermissionRoute";
import Register from "./components/Register";
import NewDashboard from "./pages/NewDashboard.jsx/NewDashboardSection";
import Dashboard from "./pages/NewDashboard/Dashboard";
import MainDashboard from "./pages/NewDashboard/MainDashboard";
import WalletServices from "./pages/WalletServices/WalletServices";

const App = () => {
  const location = useLocation();

  // If on Login page, don't render Header
  const showHeader = location.pathname !== "/";
  return (
      <div className="min-h-screen bg-gray-100">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Register" element={<Register />} />
          <Route
            path="/dashboard"
            element={
              <MainDashboard />
            }
          />


          <Route
            path="/wallet"
            element={
              <PermissionRoute
                permission="transactions-view"
                fallbackTitle="Transactions Access Denied"
                fallbackMessage="You need 'transactions-view' permission to access this page."
              >
           <WalletServices />
              </PermissionRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <PermissionRoute
                permission="transactions-view"
                fallbackTitle="Transactions Access Denied"
                fallbackMessage="You need 'transactions-view' permission to access this page."
              >
                <TransactionsPage />
              </PermissionRoute>
            }
          />
          <Route
            path="/role-management"
            element={
              <RoleManagementPage />
            }
          />
          <Route
            path="/api-credentials"
            element={
              <SettingsPage />
            }
          />
          <Route
            path="/withdraw-requests"
            element={
              <PermissionRoute
                permission="approved-withdrawals"
                fallbackTitle="Withdraw Requests Access Denied"
                fallbackMessage="You need 'approved-withdrawals' permission to access this page."
              >
                <WithdrawRequestsPage />
              </PermissionRoute>
            }
          />
          <Route
            path="/wallet-balance"
            element={
              <PermissionRoute
                permission="balance-view"
                fallbackTitle="Wallet Balance Access Denied"
                fallbackMessage="You need 'balance-view' permission to access this page."
              >
                <WalletBalancePage />
              </PermissionRoute>
            }
          />
          <Route
            path="/wallet-balances"
            element={
              <PermissionRoute
                permission="balance-view"
                fallbackTitle="Wallet Balance Access Denied"
                fallbackMessage="You need 'balance-view' permission to access this page."
              >
                <WalletBalancePage />
              </PermissionRoute>
            }
          />
          <Route
            path="/complaints"
            element={
              <PermissionRoute
                permission="complaints-view"
                fallbackTitle="Complaints Access Denied"
                fallbackMessage="You need 'complaints-view' permission to access this page."
              >
                <ComplaintsPage />
              </PermissionRoute>
            }
          />
          <Route
            path="/security/2fa"
            element={
              <AuthGuard>
                <TwoFactorAuthPage />
              </AuthGuard>
            }
          />
          <Route
            path="/settings"
            element={
              <SettingsPage />
            }
          />
          <Route
            path="/New-Dashboard/*"
            element={
              <NewDashboard />
            }
          />
          <Route
            path="/wallet-service-types"
            element={
              <AuthGuard>
                <WalletServiceTypesPage />
              </AuthGuard>
            }
          />
          <Route
            path="/wallet-service-types/:id"
            element={
              <AuthGuard>
                <WalletServiceTypeDetailPage />
              </AuthGuard>
            }
          />
        </Routes>
      </div>
  );
};

export default App;
